import {Filter, FilterGroup} from '../filterbuilder/filterbuilder.component';
import {DisplayAttribute} from '../../resource/displayattribute';
import {EnvironmentConfigService} from '../../core/services/environment-config.service';

import {ParseTreeVisitor} from '../../utils/interop/antlr4';
// @ts-ignore - Generated ANTLR files don't have TypeScript definitions
import xpathParser from './xpathParser.js';

export class xpathVisitor extends ParseTreeVisitor<any> {
  private xpathParser = xpathParser;

  constructor(private envConfigService?: EnvironmentConfigService) {
    super();
  }

  // Visit a parse tree produced by xpathParser#start.
  // start: elementNodeLocationStep EOF;
  visitStart(ctx): MyExpression {
    return this.visitElementNodeLocationStep(ctx.children[0]);
  }

  // Visit a parse tree produced by xpathParser#expression.
  // expression: locationPathExpression | functionCallExpression | expression '|' expression;
  visitExpression(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#locationPathExpression.
  // locationPathExpression: locationStep locationStep | functionCallExpression | elementNodeLocationStep;
  visitLocationPathExpression(ctx) {
    if (
      ctx.children.length === 1 &&
      ctx.children[0].ruleIndex === this.xpathParser.RULE_functionCallExpression
    ) {
      return this.visitFunctionCallExpression(ctx.children[0]);
    }

    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#locationStep.
  // locationStep: elementNodeLocationStep;
  visitLocationStep(ctx) {
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#elementNodeLocationStep.
  // elementNodeLocationStep: '/' objectType | '/' objectType predicateList;
  visitElementNodeLocationStep(ctx): MyExpression {
    if (ctx.children.length === 2) {
      return new MyExpression(this.visitObjectType(ctx.children[1]).objectType, null);
    } else if (ctx.children.length === 3) {
      return new MyExpression(
        this.visitObjectType(ctx.children[1]).objectType,
        this.visitPredicateList(ctx.children[2]),
      );
    }
  }

  // Visit a parse tree produced by xpathParser#predicateList.
  // predicateList: predicate;
  visitPredicateList(ctx) {
    return this.visitPredicate(ctx.children[0]);
  }

  // Visit a parse tree produced by xpathParser#predicate.
  // predicate: '[' predicateExpression ']';
  visitPredicate(ctx) {
    return this.visitPredicateExpression(ctx.children[1]);
  }

  private flatArray(array: any[]): any[] {
    if (!Array.isArray(array)) {
      return array;
    }
    const flat = [];
    array.forEach(a => {
      if (Array.isArray(a)) {
        const subFlat = this.flatArray(a);
        flat.push(...subFlat);
      } else {
        flat.push(a);
      }
    });
    return flat;
  }

  private negateFilterGroup(fg: FilterGroup): void {
    fg.filters.forEach(f => {
      if (f instanceof Filter) {
        f.negate = !f.negate;
      } else if (f instanceof FilterGroup) {
        this.negateFilterGroup(f);
      }
    });
    fg.operator = fg.operator === 'any' ? 'all' : 'any';
  }

  private processLogicBinding(booleanExpression: any[] | any): FilterGroup {
    let lastOperator: 'and' | 'or' = 'or';
    let mainGroup: FilterGroup = new FilterGroup(null);
    mainGroup.operator = 'any';
    if (
      booleanExpression != null &&
      typeof booleanExpression === 'object' &&
      !Array.isArray(booleanExpression)
    ) {
      if ('attribute' in booleanExpression) {
        mainGroup.filters.push(this.createFilterFromExpression(booleanExpression));
        return mainGroup;
      } else if ('negation' in booleanExpression) {
        if (booleanExpression.negation === true) {
          if (
            typeof booleanExpression.expression === 'object' &&
            'attribute' in booleanExpression.expression
          ) {
            const f = this.createFilterFromExpression(booleanExpression.expression);
            f.negate = !f.negate;
            mainGroup.filters.push(f);
            return mainGroup;
          } else {
            const fg = this.processLogicBinding(booleanExpression.expression);
            this.negateFilterGroup(fg);
            return fg;
          }
        } else {
          return this.processLogicBinding(booleanExpression.expression);
        }
      } else if ('parenthesized' in booleanExpression) {
        return this.processLogicBinding(booleanExpression.expression);
      }
    }

    let curFilters: (Filter | FilterGroup)[] = [];
    for (let i = 0; i < booleanExpression.length; i++) {
      const be = booleanExpression[i];
      if (be === 'and') {
        if (i === 0) throw new Error('Logic operator "and" at beginning of expression.');
        if (lastOperator === null) {
          lastOperator = 'and';
        } else if (lastOperator !== 'and') {
          const firstNew = curFilters.pop();
          mainGroup.filters.push(...curFilters);
          curFilters = [firstNew];
          lastOperator = 'and';
        }
      } else if (be === 'or') {
        if (i === 0) throw new Error('Logic operator "or" at beginning of expression.');
        if (lastOperator === null) {
          lastOperator = 'or';
        } else if (lastOperator !== 'or') {
          const fg = new FilterGroup(null);
          fg.filters.push(...curFilters);
          fg.operator = 'all';
          mainGroup.filters.push(fg);
          curFilters = [];
          lastOperator = 'or';
        }
      } else {
        if (be != null && typeof be === 'object') {
          if ('parenthesized' in be && be.parenthesized === true) {
            const f = this.processLogicBinding(be.expression);
            if (f instanceof FilterGroup && f.filters.length === 1) {
              curFilters.push(f.filters[0]);
            } else {
              curFilters.push(f);
            }
          } else if ('negation' in be && be.negation === true) {
            if (be.expression != null && 'attribute' in be.expression) {
              const f = this.createFilterFromExpression(be.expression);
              f.negate = !f.negate;
              curFilters.push(f);
            } else {
              const fg = this.processLogicBinding(be.expression);
              this.negateFilterGroup(fg);
              if (fg.filters.length === 1) {
                curFilters.push(fg.filters[0]);
              } else {
                curFilters.push(fg);
              }
            }
          } else {
            curFilters.push(this.createFilterFromExpression(be));
          }
        } else {
          // curFilters.push(this.createFilterFromExpression(be));
          console.error('Parser: non-object BooleanExpression cannot be parsed', be);
        }
      }
    }
    if (curFilters.length !== 0 && lastOperator != null) {
      if (lastOperator === 'and') {
        const fg = new FilterGroup(null);
        fg.filters.push(...curFilters);
        fg.operator = 'all';
        mainGroup.filters.push(fg);
      } else if (lastOperator === 'or') {
        mainGroup.filters.push(...curFilters);
      }
    }

    if (mainGroup.filters.length === 1 && mainGroup.filters[0] instanceof FilterGroup) {
      return <FilterGroup>mainGroup.filters[0];
    } else {
      return mainGroup;
    }
  }

  private createFilterFromExpression(ex: {attribute; operator; value}): Filter {
    const f = new Filter(null, DisplayAttribute.getLocalAttribute(ex.attribute));
    if (ex.value === '%LoginID%' && (ex.operator === '=' || ex.operator === '!=')) {
      f.negate = ex.operator === '!=';
      f.keyword = 'LoggedInUser';
      f.search = null;
      return f;
    }
    if (ex.value === '%ObjectID%' && (ex.operator === '=' || ex.operator === '!=')) {
      f.negate = ex.operator === '!=';
      f.keyword = 'TargetObject';
      f.search = null;
      return f;
    }
    f.keyword = ex.operator;

    f.search = ex.value;
    if (ex.value instanceof Date) {
      f.dateTimeCase = 'specificDate';
    }

    if (typeof ex.value === 'object' && ex.value != null && 'type' in ex.value) {
      if (ex.value.type === 'functionCall') {
        if (ex.value.name === 'current-dateTime') {
          f.dateTimeCase = 'today';
          f.search = undefined;
        } else if (ex.value.name === 'subtract-dayTimeDuration-from-dateTime') {
          f.dateTimeCase = 'daysAgo';
          const dt = ex.value.dateTime;
          const dtd = ex.value.dayTimeDuration;
          if (
            dt != null &&
            dtd != null &&
            typeof dt === 'object' &&
            typeof dtd === 'object' &&
            'type' in dt &&
            'type' in dtd &&
            dt.type === 'functionCall' &&
            dt.name === 'current-dateTime' &&
            dtd.type === 'functionCall' &&
            dtd.name === 'dayTimeDuration'
          ) {
            const matches = /^P([0-9]+)D$/.exec(dtd.arg);
            if (matches != null && matches[1] != null) {
              f.search = parseInt(matches[1]);
            }
          }
        } else if (ex.value.name === 'add-dayTimeDuration-to-dateTime') {
          f.dateTimeCase = 'daysFromToday';
          const dt = ex.value.dateTime;
          const dtd = ex.value.dayTimeDuration;
          if (
            dt != null &&
            dtd != null &&
            typeof dt === 'object' &&
            typeof dtd === 'object' &&
            'type' in dt &&
            'type' in dtd &&
            dt.type === 'functionCall' &&
            dt.name === 'current-dateTime' &&
            dtd.type === 'functionCall' &&
            dtd.name === 'dayTimeDuration'
          ) {
            const matches = /^P([0-9]+)D$/.exec(dtd.arg);
            if (matches != null && matches[1] != null) {
              f.search = parseInt(matches[1]);
            }
          }
        }
      }
    }

    f.negate = false;
    return f;
  }

  // Visit a parse tree produced by xpathParser#predicateExpression.
  // predicateExpression: booleanExpression | equalityExpression | relationalExpression;
  visitPredicateExpression(ctx) {
    const c = ctx.children[0];
    switch (c.ruleIndex) {
      case this.xpathParser.RULE_booleanExpression:
        // check operator priority (and bindet stärker)
        const be = this.flatArray(this.visitBooleanExpression(c));
        return this.processLogicBinding(be);
      case this.xpathParser.RULE_equalityExpression:
        const eqEx = this.visitEqualityExpression(c);
        const fe = new Filter(null, DisplayAttribute.getLocalAttribute(eqEx.attribute));
        fe.negate = eqEx.operator === '!=';
        if (eqEx.value === '%LoginID%') {
          fe.keyword = 'LoggedInUser';
          fe.search = null;
        } else if (eqEx.value === '%ObjectID%') {
          fe.keyword = 'TargetObject';
          fe.search = null;
        } else {
          fe.keyword = '=';
          fe.search = eqEx.value;
        }
        return fe;
      case this.xpathParser.RULE_relationalExpression:
        const rEx = this.visitRelationalExpression(c);
        const fr = new Filter(null, DisplayAttribute.getLocalAttribute(rEx.attribute));
        fr.negate = false;
        fr.keyword = rEx.operator;
        fr.search = rEx.value;
        return fr;
    }
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#equalityExpression.
  // equalityExpression: attribute equalityOperator rightEqualityTerm;
  visitEqualityExpression(ctx) {
    let attribute, value, operator;
    ctx.children.forEach(c => {
      switch (c.ruleIndex) {
        case this.xpathParser.RULE_attribute:
          attribute = this.visitAttribute(c);
          break;
        case this.xpathParser.RULE_equalityOperator:
          operator = this.visitEqualityOperator(c);
          break;
        case this.xpathParser.RULE_rightEqualityTerm:
          value = this.visitRightEqualityTerm(c);
          break;
      }
    });

    if (
      operator === '=' &&
      typeof value === 'object' &&
      'type' in value &&
      value.type === 'subQuery'
    ) {
      if (
        Array.isArray(value.value) &&
        value.value.length === 2 &&
        Array.isArray(value.value[0]) &&
        value.value[0].length === 1 &&
        Array.isArray(value.value[1]) &&
        value.value[1].length === 1 &&
        value.value[0][0] instanceof MyExpression &&
        value.value[1][0] instanceof MyExpression
      ) {
        const e1: MyExpression = value.value[0][0];
        const e2: MyExpression = value.value[1][0];

        if (
          (e2.objectType === 'ComputedMember' || e2.objectType === 'ExplicitMember') &&
          e2.mainFilterGroup == null &&
          e1.mainFilterGroup != null &&
          e1.mainFilterGroup.filters != null &&
          Array.isArray(e1.mainFilterGroup.filters) &&
          e1.mainFilterGroup.filters.length === 1 &&
          e1.mainFilterGroup.filters[0] instanceof Filter
        ) {
          // TODO: handle ExplicitMember differently???
          const f: Filter = <Filter>e1.mainFilterGroup.filters[0];
          const objectIdAttrName =
            this.envConfigService?.getAttributeName('ObjectID') || 'ObjectID';
          if (
            f.attribute != null &&
            f.attribute.Name === objectIdAttrName &&
            f.keyword === '=' &&
            f.negate === false
          ) {
            operator = 'in';
            value = f.search;
          }
        }
      }
    }

    return {attribute: attribute, operator: operator, value: value};
  }

  // Visit a parse tree produced by xpathParser#equalityOperator.
  // equalityOperator: '=' | '!=';
  visitEqualityOperator(ctx) {
    let op = null;
    try {
      op = ctx.children[0].symbol.text;
    } catch (e) {}

    return op;
  }

  // Visit a parse tree produced by xpathParser#rightEqualityTerm.
  // rightEqualityTerm: locationPathExpression | functionCallExpression | booleanToken | dateTime | number | string;
  visitRightEqualityTerm(ctx) {
    const c = ctx.children[0];
    switch (ctx.children[0].ruleIndex) {
      case this.xpathParser.RULE_locationPathExpression:
        return {type: 'subQuery', value: this.visitLocationPathExpression(c)};
      case this.xpathParser.RULE_functionCallExpression:
        return {type: 'functionCall', value: this.visitFunctionCallExpression(c)};
      case this.xpathParser.RULE_booleanToken:
        return this.visitBooleanToken(c);
      // case 'this.xpathParser.RULE_dateTime':
      //     return this.visitDateTime(c);
      case this.xpathParser.RULE_number:
        return this.visitNumber(c);
      case this.xpathParser.RULE_string:
        return this.visitString(c);
    }
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#booleanToken.
  // booleanToken: 'true' | 'false' | 'True' | 'False' | 'TRUE' | 'FALSE';
  visitBooleanToken(ctx) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      if (typeof v === 'boolean') {
        v = v === true ? 'true' : 'false';
      } else if (typeof v === 'string') {
        v = v.toLowerCase() === 'true' ? 'true' : 'false';
      }
    } catch (e) {}
    return v;
  }

  // Visit a parse tree produced by xpathParser#relationalExpression.
  // relationalExpression : attribute relationalOperator rightRelationalTerm;
  visitRelationalExpression(ctx) {
    let attribute, value, operator;
    ctx.children.forEach(c => {
      switch (c.ruleIndex) {
        case this.xpathParser.RULE_attribute:
          attribute = this.visitAttribute(c);
          break;
        case this.xpathParser.RULE_relationalOperator:
          operator = this.visitRelationalOperator(c);
          break;
        case this.xpathParser.RULE_rightRelationalTerm:
          value = this.visitRightRelationalTerm(c);
          break;
      }
    });

    return {attribute: attribute, operator: operator, value: value};
  }

  // Visit a parse tree produced by xpathParser#relationalOperator.
  // relationalOperator: '<=' | '<' | '>=' | '>' | '&lt;=' | '&lt;' | '&gt;=' | '&gt;';
  visitRelationalOperator(ctx) {
    let op = null;
    try {
      op = ctx.children[0].symbol.text;
      op = op.replace('&lt;', '<').replace('&gt;', '>');
    } catch (e) {}

    return op;
  }

  // Visit a parse tree produced by xpathParser#rightRelationalTerm.
  // rightRelationalTerm: functionCallExpression | locationPathExpression | number | dateTime;
  visitRightRelationalTerm(ctx) {
    const c = ctx.children[0];
    switch (ctx.children[0].ruleIndex) {
      case this.xpathParser.RULE_functionCallExpression:
        return this.visitFunctionCallExpression(c);
      case this.xpathParser.RULE_locationPathExpression:
        return {type: 'subQuery', value: this.visitLocationPathExpression(c)};
      case this.xpathParser.RULE_number:
        return this.visitNumber(c);
      case this.xpathParser.RULE_string:
        // case 'this.xpathParser.RULE_dateTime':
        return this.visitDateTime(c);
    }
    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#booleanExpression.
  // booleanExpression: booleanTerm | booleanTerm booleanOperator  booleanTerm |
  //    booleanExpression booleanOperator booleanTerm |
  //    '(' booleanExpression ')' booleanOperator booleanTerm | '(' booleanExpression ')';
  visitBooleanExpression(ctx) {
    if (ctx.children.length === 1) {
      const c = ctx.children[0];
      if (c.ruleIndex === this.xpathParser.RULE_booleanTerm) {
        return this.visitBooleanTerm(c);
      }
    }

    return this.visitChildren(ctx);
  }

  // Visit a parse tree produced by xpathParser#booleanTerm.
  // booleanTerm:  locationPathExpression | equalityExpression | relationalExpression | '(' booleanExpression ')';
  visitBooleanTerm(ctx) {
    if (ctx.children.length === 1) {
      const c = ctx.children[0];
      return this.visit(c);
    } else {
      let ex = this.visitBooleanExpression(ctx.children[1]);
      if (ex != null && 'parenthesized' in ex && ex.parenthesized === true) {
        ex = ex.expression;
      }
      return {parenthesized: true, expression: this.flatArray(ex)};
    }
  }

  // Visit a parse tree produced by xpathParser#booleanOperator.
  // booleanOperator: 'and' | 'or';
  visitBooleanOperator(ctx) {
    let op = null;
    try {
      op = ctx.children[0].symbol.text;
    } catch (e) {}

    return op;
  }

  // Visit a parse tree produced by xpathParser#functionCallExpression.
  // functionCallExpression: functionName '(' parameterList ')' | functionName '(' ')';
  visitFunctionCallExpression(ctx) {
    const name = this.visitFunctionName(ctx.children[0]);
    if (ctx.children.length === 3) {
      if (name === 'current-dateTime') {
        return {type: 'functionCall', name: name};
      } else {
        throw Error('No parameters for function ' + name);
      }
    }

    const parameterList = this.visitParameterList(ctx.children[2]);

    switch (name) {
      case 'contains':
      case 'starts-with':
      case 'ends-with':
        if (parameterList.length !== 2) throw Error('Invalid parameters for function ' + name);
        if (parameterList[0].ruleIndex !== this.xpathParser.RULE_attribute)
          throw Error('Invalid parameter types for function ' + name);
        if (parameterList[1].ruleIndex !== this.xpathParser.RULE_string)
          throw Error('Invalid parameter types for function ' + name);
        return {
          attribute: this.visitAttribute(parameterList[0]),
          operator: name,
          value: this.visitString(parameterList[1]),
        };
      case 'not':
        if (parameterList.length !== 1) throw Error('Invalid parameters for function ' + name);
        return {
          negation: true,
          expression: this.visit(parameterList[0]),
        };
      case 'add-dayTimeDuration-to-dateTime':
      case 'subtract-dayTimeDuration-from-dateTime':
        if (parameterList.length !== 2) throw Error('Invalid parameters for function ' + name);
        return {
          type: 'functionCall',
          name: name,
          dateTime: this.visit(parameterList[0]),
          dayTimeDuration: this.visit(parameterList[1]),
        };
      case 'add-yearMonthDuration-to-dateTime':
      case 'subtract-yearMonthDuration-from-dateTime':
        if (parameterList.length !== 2) throw Error('Invalid parameters for function ' + name);
        return {
          type: 'functionCall',
          name: name,
          dateTime: this.visit(parameterList[0]),
          yearMonthDuration: this.visit(parameterList[1]),
        };
      case 'dateTime':
      case 'dayTimeDuration':
        if (parameterList.length !== 1) throw Error('Invalid parameters for function ' + name);
        return {
          type: 'functionCall',
          name: name,
          arg: this.visit(parameterList[0]),
        };
    }
    return {type: 'functionCall', value: this.visitChildren(ctx)};
  }

  // Visit a parse tree produced by xpathParser#parameterList.
  // parameterList: parameter | parameterList ',' parameter;
  visitParameterList(ctx) {
    const parameters = [];
    let curCtx = ctx;
    while (curCtx.children.length === 3) {
      parameters.push(curCtx.children[2].children[0]);
      curCtx = curCtx.children[0];
    }
    parameters.push(curCtx.children[0].children[0]);

    return parameters.reverse();
  }

  // Visit a parse tree produced by xpathParser#parameter.
  // parameter: attribute | locationPathExpression | equalityExpression | booleanExpression | functionCallExpression | number | dateTime | string;
  visitParameter(ctx) {
    return this.visit(ctx.children[0]);
  }

  // Visit a parse tree produced by xpathParser#functionName.
  // functionName: FnFunction | OpFunction | XsFunction;
  visitFunctionName(ctx) {
    let fn = null;
    try {
      fn = ctx.children[0].symbol.text;
      if (fn.indexOf('fn:') === 0 || fn.indexOf('op:') === 0 || fn.indexOf('xs:') === 0) {
        fn = fn.substring(3);
      }
    } catch (e) {}
    return fn;
  }

  // Visit a parse tree produced by xpathParser#objectType.
  // objectType: QNAME | OT_ALL;
  visitObjectType(ctx) {
    let ot = null;
    try {
      ot = ctx.children[0].symbol.text;
    } catch (e) {}

    return {
      objectType: ot,
    };
  }

  // Visit a parse tree produced by xpathParser#attribute.
  // attribute: QNAME;
  visitAttribute(ctx) {
    // const e = new MyExpression();
    let a = null;
    try {
      a = ctx.children[0].symbol.text;
    } catch (e) {}

    return a;
  }

  // Visit a parse tree produced by xpathParser#number.
  // number: NUMBER;
  visitNumber(ctx) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      if (typeof v !== 'number') {
        v = parseInt(v);
      }
    } catch (e) {}
    return v;
  }

  // Visit a parse tree produced by xpathParser#string.
  // string: STRING;
  visitString(ctx) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      v = v.substr(1, v.length - 2);
    } catch (e) {}

    return v;
  }

  // Visit a parse tree produced by xpathParser#dateTime.
  // dateTime: DATETIME;
  visitDateTime(ctx) {
    let v = null;
    try {
      v = ctx.children[0].symbol.text;
      v = v.substr(1, v.length - 2);
      v = new Date(v);
    } catch (e) {}

    return v;
  }
}

export class MyExpression {
  constructor(
    public objectType: string,
    public mainFilterGroup: FilterGroup,
  ) {}
}
